module.exports = __webpack_public_path__ + "static/media/calendar-days.f0aa2619.svg";